// API URL for Firebase Functions
export const API_URL = 'https://api-aytscqukiq-uc.a.run.app/v1';

// Default timeout for API requests in milliseconds  
export const API_TIMEOUT = 10000;

// Storage keys for localStorage
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'bunny_boba_auth_token',
  USER_DATA: 'bunny_boba_user_data', 
  CART_ITEMS: 'bunny_boba_cart_items'
};

// Theme colors to match current website
export const COLORS = {
  primary: '#ff9dd4',
  secondary: '#a855f7', 
  white: '#ffffff',
  black: '#000000',
  text: '#333333',
  textLight: '#666666',
  background: '#fff8f0',
  card: '#fcf0ff',
  border: '#e5e5e5',
  success: '#10b981',
  error: '#ef4444',
  warning: '#f59e0b'
}; 